import { graphql, type Environment } from 'react-relay/legacy';
import commitMutation from 'relay-commit-mutation-promise';

import {
    type SubmitSellerApplicationLeadInput as Input,
    type submitSellerApplicationLeadMutation as Mutation,
    type submitSellerApplicationLeadMutation$data as Response,
} from './__generated__/submitSellerApplicationLeadMutation.graphql';

const mutation = graphql`
    mutation submitSellerApplicationLeadMutation($input: SubmitSellerApplicationLeadInput!) {
        SubmitSellerApplicationLead(input: $input) {
            leadId
            pass
        }
    }
`;

export const submitSellerApplicationLeadMutation = (
    environment: Environment,
    input: Input
): Promise<Response> =>
    commitMutation<Mutation>(environment, {
        mutation,
        variables: { input },
    });
